import { Button, Divider, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react'
import colorConfigs from '../../../configs/colorConfigs';
import { useTheme } from '../../../components/hooks/useTheme';
import SendEmailPopup from './SendEmailPopup';


type RentalAndRecieptButtonProps = {
    reservationId: number;
    isVehicleReplaced: boolean;
    bookingNumber: string;
    customerName: string;
    customerEmail: string;
}

const RentalAndRecieptButton = ({
    reservationId,
    isVehicleReplaced,
    bookingNumber,
    customerName,
    customerEmail
}: RentalAndRecieptButtonProps) => {
    const { themeStyles } = useTheme();

    const [openSendEmailPopup, setOpenSendEmailPopup] = useState<boolean>(false);
    const [emailType, setEmailType] = useState<string>("Agreement");

    //Agreement
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    //Receipt
    const [anchorE2, setAnchorE2] = useState<null | HTMLElement>(null);
    const open2 = Boolean(anchorE2);

    const handleClick2 = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorE2(event.currentTarget);
    };

    const handleClose2 = () => {
        setAnchorE2(null);
    };

    const printTheAgreement = () => {
        window.open(`/carrental/reservations/print-agreement?id=${reservationId}`, "_blank", "noopener,noreferrer");
    }

    const emailTheAgreement = () => {
        setEmailType("Agreement");
        setOpenSendEmailPopup(true);
    }

    const printTheReceipt = () => {
        window.open(`/carrental/reservations/print-receipt?id=${reservationId}`, "_blank", "noopener,noreferrer");
    }

    const emailTheReceipt = () => {
        setEmailType("Receipt");
        setOpenSendEmailPopup(true);
    }


    return (
        <>
            <div className="flex items-center gap-x-[0.5rem]">
                <div className="">
                    <Button variant="contained"
                        sx={{
                            backgroundColor: colorConfigs.btn.main.bg
                        }}
                        type="button"
                        onClick={handleClick}
                    >
                        Agreement
                        {
                            open
                                ? (
                                    <span className={`material-symbols-outlined text-white text-[25px] font-extralight`}>
                                        keyboard_arrow_up
                                    </span>
                                ) : (
                                    <span className={`material-symbols-outlined text-white text-[25px] font-extralight`}>
                                        keyboard_arrow_down
                                    </span>
                                )
                        }
                    </Button>

                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        slotProps={{
                            paper: {
                                sx: {
                                    width: 170,
                                    backgroundColor: themeStyles.topBar.bg
                                }
                            }
                        }}
                    >
                        <MenuItem
                            sx={{ fontSize: "12px", marginBlock: "0px" }}
                            onClick={() => {
                                setAnchorEl(null);
                                printTheAgreement();
                            }}
                        >
                            <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium`}>Print Agreement</span>
                        </MenuItem>

                        <Divider className="w-full" />

                        <MenuItem
                            sx={{ fontSize: "12px", marginBlock: "0px" }}
                            onClick={() => {
                                setAnchorEl(null);
                                emailTheAgreement();
                            }}
                        >
                            <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium`}>Email Agreement</span>
                        </MenuItem>
                    </Menu>
                </div>

                <div className="">
                    <Button variant="contained"
                        sx={{
                            backgroundColor: colorConfigs.btn.main.bg
                        }}
                        type="button"
                        onClick={handleClick2}
                    >
                        Receipt
                        {
                            open2
                                ? (
                                    <span className={`material-symbols-outlined text-white text-[25px] font-extralight`}>
                                        keyboard_arrow_up
                                    </span>
                                ) : (
                                    <span className={`material-symbols-outlined text-white text-[25px] font-extralight`}>
                                        keyboard_arrow_down
                                    </span>
                                )
                        }
                    </Button>

                    <Menu
                        id="basic-menu"
                        anchorEl={anchorE2}
                        open={open2}
                        onClose={handleClose2}
                        slotProps={{
                            paper: {
                                sx: {
                                    width: 170,
                                    backgroundColor: themeStyles.topBar.bg
                                }
                            }
                        }}
                    >
                        <MenuItem
                            sx={{ fontSize: "12px", marginBlock: "0px" }}
                            onClick={() => {
                                setAnchorE2(null);
                                printTheReceipt();
                            }}
                        >
                            <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium`}>Print Receipt</span>
                        </MenuItem>

                        <Divider className="w-full" />

                        <MenuItem
                            sx={{ fontSize: "12px", marginBlock: "0px" }}
                            onClick={() => {
                                setAnchorE2(null);
                                emailTheReceipt();
                            }}
                        >
                            <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium`}>Email Receipt</span>
                        </MenuItem>
                    </Menu>
                </div>
            </div>

            <SendEmailPopup
                open={openSendEmailPopup}
                onClose={() => setOpenSendEmailPopup(false)}
                emailType={emailType}
                reservationId={reservationId}
                isVehicleReplaced={isVehicleReplaced}
                bookingNumber={bookingNumber}
                customerName={customerName}
                customerEmail={customerEmail}
            />
        </>
    )
}

export default RentalAndRecieptButton